import {http} from './index'
import utils from "@/utils";
import ElementUI, {Message} from "element-ui";

function request(url, method, data) {
    return http({
        url: url,
        method: method,
        data: data
    })
}

function requestBuffer(url, method, data) {
    return http({
        url: url,
        method: method,
        data: data,
        responseType: 'arraybuffer'
    })
}

export function downloadData(url, data, fileName) {
    return requestBuffer(url, 'post', data).then(data => {
        try {
            let enc = new TextDecoder('utf-8')
            let body = JSON.parse(enc.decode(new Uint8Array(data.data)))
            if (body.status !== 0) {
                Message({
                    type: "error",
                    message: body.msg
                });
            }
        } catch (error) {
            console.log(error)
            let blobObject = new Blob([data.data]);
            //是IE浏览器
            if (!!window.ActiveXObject || "ActiveXObject" in window) {
                window.navigator.msSaveOrOpenBlob(blobObject, fileName);
            } else {//火狐谷歌都兼容
                //模板中要有一个预定义好的a标签
                let link = document.createElement("a");
                link.href = URL.createObjectURL(blobObject);
                link.download = fileName;
                link.click();
            }
            ElementUI.Message({
                message: '导出Excel成功！',
                type: "success",
            })
        }
    })
}

export function formatDate(row, column) {
    return utils.DateUtil.formatDate(row[column.property], "YYYY-MM-DD HH:mm:ss")
}

function get(url, data) {
    return request(url, 'get', data)
}

function post(url, data) {
    return request(url, 'post', data)
}

export function userLogin(data) {
    return post('/admin/user/login', data)
}

export function permissionTest() {
    return get('/admin/user/permissionTest')
}

export function userList() {
    return get('/admin/user/list')
}

export function userLogout() {
    return get('/admin/user/logout')
}

export function searchUserList(data) {
    return post('/admin/user/search', data)
}

export function userForbidden(_accountId) {
    return get('/admin/user/forbidden/' + _accountId)
}

export function userAdd(data) {
    return post('/admin/user/add', data)
}

export function updatePassword(data) {
    return post('/admin/user/updatePassword', data)
}

export function allIndexStyles() {
    return get('/plate/allStyles')
}

export function allLabels() {
    return get('/plate/allLabels')
}

export function plateRuleList() {
    return get('/plate/list')
}

export function eventListByType(type) {
    return post('/event/listByType?type=' + type)
}

export function plateReportList(_state) {
    return get('/plate/listPlateReport/' + _state)
}

export function plateReportSearch(data) {
    return post('/plate/searchPlateReport', data)
}

export function eventPlateReportSearch(data) {
    return post('/plate/searchEventPlateReport', data)
}

export function listRulesByPlateStyles(_index) {
    return get('/plate/list/' + _index)
}

export function searchListRulesByChannel(_index, data) {
    return post('/plate/searchByChannel/' + _index, data)
}

export function plateRankUp(_index) {
    return post('/plate/rankUp/' + _index)
}

export function plateRankDown(_idx) {
    return post('/plate/rankDown/' + _idx)
}

export function rankEdit(_id, _rank) {
    return post('/plate/rankEdit/' + _id + '/' + _rank)
}

export function updatePlateState(_state, _id) {
    return post('/plate/updateState/' + _state + '/' + _id)
}

export function deletePlate(_id) {
    return post('/plate/delete/' + _id);
}

export function editPlate(data) {
    return post('/plate/edit', data)
}

export function addSelector(_plateId, _gameId) {
    return post('/plate/selector/add/' + _plateId + '/' + _gameId)
}

export function deleteSelector(_id) {
    return post('/plate/selector/delete/' + _id)
}

export function batchDelete(ids) {
    return post('/plate/selector/batchDelete/', ids)
}

export function batchAdd(plateId, gameSelectors) {
    return post('/plate/selector/batchAdd/' + plateId, gameSelectors)
}

export function batchSubChannelAdd(plateId, plateToSubChannel) {
    return post('/plate/subChannel/batchSubChannelAdd/' + plateId, plateToSubChannel)
}

export function editValidDate(_id, _dt) {
    return post('/plate/editValidDate/' + _id + '/' + _dt)
}

export function listSelector(_id) {
    return get('/plate/selector/list/' + _id)
}

export function selectorList() {
    return get('/plate/selector/list')
}

export function editSelector(_id, _rank) {
    return post('/plate/selector/edit/' + _id + '/' + _rank)
}

export function cateList() {
    return get('/category/list')
}

export function categoryEdit(data) {
    return post('/category/edit', data)
}

export function categoryDelete(_level, _id) {
    return post('/category/delete/' + _level + '/' + _id)
}

export function channelList() {
    return get('/channel/list')
}

export function kittyChannelList() {
    return get('/channel/list')
}

export function adPlateEnum() {
    return get('/channel/adPlateEnum')
}

export function channelEdit(data) {
    return post('/channel/edit', data)
}

export function updateState(_state, _id) {
    return post('/channel/updateState/' + _state + '/' + _id)
}

export function appAll() {
    return get('/channel/listApp')
}

export function appEdit(data) {
    return post('/channel/editApp', data)
}

export function eventListEvent() {
    return get('/event/listEvent')
}

//查询全部pop标签
export function eventList() {
    return get('/event/list')
}

export function eventEdit(data) {
    return post('/event/edit', data)
}

export function gameListForAdmin() {
    return get('/game/gameListForAdmin')
}

export function gameList() {
    return get('/game/list')
}

export function gameRunningList() {
    return get('/game/running/list')
}

export function gameUpload(data) {
    return post('/game/upload', data)
}

export function gameEdit(data) {
    return post('/game/edit', data)
}

export function gameSearch(data) {
    return post('/game/search', data)
}

export function gameSimpleList() {
    return get('/game/simpleList')
}

export function gameUploadPackage(data) {
    return post('/game/uploadPackage', data)
}

export function gameVersionDelete(_gameVersionId) {
    return post('/game/deleteGameVersion/' + _gameVersionId)
}

export function gameRelease(_gameVersionId) {
    return post('/game/releaseGameVersion/' + _gameVersionId)
}

export function gameOffShelves(_gameVersionId) {
    return post('/game/getOffShelves/' + _gameVersionId)
}

export function gameVersionList(_gameId) {
    return get('/game/listGameVersion/' + _gameId)
}

export function gameDelete(_gameId) {
    return post('/game/deleteGame/' + _gameId)
}

export function gameVersionEdit(data) {
    return post('/game/editVersion', data)
}

export function gameReportList() {
    return get('/game/listGameReport')
}

export function gameSearchGameReport(data) {
    return post('/game/searchGameReport', data)
}

export function gameSelectorSearch(data) {
    return post('/game/search/selection', data)
}

export function matrixGameReportList() {
    return get('/matrix/listMatrixGameReport')
}

export function searchMatrixGameReportList(data) {
    return post('/matrix/searchMatrixGameReport', data)
}

export function listPlateGameReport() {
    return get('/plate/listPlateGameReport')
}

export function searchPlateGameReport(data) {
    return post('/plate/searchPlateGameReport', data)
}

export function listJumpGameReport() {
    return get('/matrix/listJumpGameReport')
}

export function searchJumpGameReport(data) {
    return post('/matrix/searchJumpGameReport', data)
}

export function gameMatchList() {
    return get('/gameMatch/list')
}

export function addMatchGame(data) {
    return post('/gameMatch/add', data)
}

export function editMatchGame(data) {
    return post('/gameMatch/edit', data)
}

export function deleteMatchGame(_id) {
    return post('/gameMatch/delete/' + _id)
}

export function batchMatchAdd(matchId, gameSelectors) {
    return post('/gameMatch/selector/batchAdd/' + matchId, gameSelectors)
}

export function listMatchSelector(_id) {
    return get('/gameMatch/selector/list/' + _id)
}

export function selectorMatchList() {
    return get('/gameMatch/selector/list')
}

export function gameMatchSelectorSearch(data) {
    return post('/gameMatch/selection', data)
}

export function gameMatchCopy(_id) {
    return get('/gameMatch/copy/' + _id)
}

export function addNotInList() {
    return get('/gameMatch/addNotInList')
}

//条件 查询游戏匹配
export function searchGameMatch(data) {
    return post('/gameMatch/search', data)
}

//------------------------------------------发现页相关接口
//查询全部发现页规则  及 搜索发现页接口
export function searchDiscoverRules(data) {
    return post('/discover/search', data)
}

export function discoverList() {
    return get('/discover/list/')
}

//增加/复制 板块规则 如果传入discoverId的话进行复制选品操作
export function addDiscoverRule(id, data) {
    return post('/discover/add?discoverId=' + id, data)
}

//修改板块规则
export function editDiscoverRule(data) {
    return post('/discover/edit', data)
}

//删除板块规则
export function deleteDiscoverRule(id) {
    return get('/discover/delete/' + id)
}

//修改板块开关状态
export function changeStateDiscoverRule(id) {
    return get('/discover/state/' + id)
}

export function changeClickedDiscoverRule(id) {
    return get('/discover/clicked/' + id)
}

export function refreshTime(id) {
    return get('/discover/refreshTime/' + id)
}

export function batchAddWeight(id, data) {
    return post('/discover/weight/batchAdd/' + id, data)
}

export function weightSearch(id) {
    return get('/discover/weight/search/' + id)
}

//------------------------------------------发现页-视频选品 相关接口
//查询发现页选品接口
export function searchDiscoverSelector(data) {
    return post('/discover/selector/search', data)
}

//查询已选视频选品列表
export function selectedDiscoverSelector(id) {
    return get('/discover/selector/selected?discoverId=' + id)
}

//批量新增视频选品接口
export function batchAddDiscoverSelector(id, data) {
    return post('/discover/selector/batchAdd/' + id, data)
}

// 视频管理开始
export function queryVideos(data) {
    return post('/video/list', data)
}

export function removeVideo(data) {
    return post('/video/remove', data)
}

export function saveOrUpdateVideo(data) {
    return post('/video/saveOrUpdate', data)
}

export function videoList() {
    return get('/video/all')
}

export function searchVideoReport(data) {
    return post('/video/searchVideoReport', data)
}

// 视频管理结束

// 头像管理开始
export function queryHeads(data) {
    return post('/head/list', data)
}

export function updateHead(data) {
    return post('/head/update', data)
}

// 头像管理结束

// cdn管理开始
export function cdnFresh(url) {
    return post('/cdn/fresh?url=' + url)
}

export function cdnQuery(taskId) {
    return post('/cdn/query?taskId=' + taskId)
}

// cdn管理结束

// 发货管理开始
export function queryPrizeReceive(data) {
    return post('/packet/receiveList', data)
}

export function updatePrizeReceive(data) {
    return post('/packet/updateReceive', data)
}

export function receiveType() {
    return post('/packet/receiveType')
}

// 发货管理结束

// 提现报告开始
export function queryCashOutUserReport(data) {
    return post('/cash/cashOurUserReport', data)
}

export function queryCashOutDailyReport(data) {
    return post('/cash/cashOurDailyReport', data)
}

export function cashOutStatus() {
    return post('/cash/cashOutStatus')
}

// 提现报告结束

//活动管理开始
export function activityList() {
    return get('/activity/list')
}

export function allSelectData() {
    return get('/activity/allSelectData')
}

export function saveActivity(data) {
    return post('/activity/create', data)
}

export function updateActivity(_id, data) {
    return post('/activity/update/' + _id, data)
}

export function searchActivitiesByChannel(data) {
    return post('/activity/searchByChannel', data)
}

export function activitySummaryList() {
    return get('/activity/activityList')
}

export function searchActivitySummary(data) {
    return post('/activity/searchActivitySummary', data)
}

export function searchDailyActivitySummary(data) {
    return post('/daily/dailyActivity', data)
}

export function searchPieceSummary(data) {
    return post('/daily/dailyActivityPiece', data)
}

export function searchPrizeReport(data) {
    return post('/packet/report/search', data)
}

export function savePieceActivity(data) {
    return post('/daily/edit', data)
}

export function pieceActivityList(data) {
    return post('/daily/list', data)
}

export function addPrize(data) {
    return post('/daily/addPrize', data)
}

export function editRelation(data) {
    return post('/daily/editRelation', data)
}


export function updateRank(data) {
    return post('/daily/update', data)
}


export function updateOfferLimit(data) {
    return post('/daily/updateOfferLimit', data)
}

export function findPrizeByAid(id) {
    return get('/daily/findPrizeByAid/' + id)
}

export function totalWeight() {
    return get('/daily/weight')
}

//活动管理结束

//游戏来源日报 开始


export function searchGameSourceReport(data) {
    return post('/data/source/search', data)
}

export function searchMiniReport(data) {
    return post('/mini/report', data)
}

export function searchPlateList(subChannel) {
    return get('/data/const/plateList?subChannel=' + subChannel)
}

export function searchUserBehaviorReport(data) {
    return post('/data/user/search', data)
}

export function searchUserGameReport(data) {
    return post('/data/user/searchGame', data)
}

//游戏来源日报 结束

//背包管理相关接口


//获取全部背包list
export function allPacketList() {
    return get('/packet/admin/list')
}

export function allEnablePacketList() {
    return get('/packet/admin/list/enable')
}

export function typePacketInfo() {
    return get('/packet/type/info')
}

export function addPacket(data) {
    return post('/packet/admin/add', data)
}

export function editPacket(data) {
    return post('/packet/admin/edit', data)
}

export function changeStatePacket(id) {
    return get('/packet/admin/state/' + id)
}

export function getPrizePiece(id) {
    return get('/packet/admin/list/relation?parentId=' + id)
}

export function batchConfigPiece(data) {
    return post('/packet/admin/batch', data)
}


//背包管理相关接口   结束
//任务管理相关接口   开始
//获取全部任务list
export function allTaskList(type) {
    return get('/task/admin/list?activityType=' + type)
}

export function typeTaskInfo() {
    return get('/task/type/info')
}

export function addTask(data) {
    return post('/task/admin/add', data)
}

export function editTask(data) {
    return post('/task/admin/edit', data)
}

export function changeStateTask(id, state) {
    return get('/task/admin/state/' + id + '/' + state)
}

export function changeTaskOrder(data) {
    return post('/task/admin/change/order', data)
}

export function allActivityTypeInfo() {
    return get('/task/activity/type/info')
}

export function batchChangeTask(data) {
    return post('/task/admin/batchChange', data)
}

export function saveDailyTask(data) {
    return post('/task/admin/batchAdd', data)
}

export function changeDailyTaskOrder(data) {
    return post('/task/admin/change/groupOrder', data)
}

//任务管理相关接口   结束

//提现配置接口
export function addCash(data) {
    return post('/cash/save', data)
}

export function addRate(data) {
    return post('/cash/create', data)
}

export function rateList() {
    return get('/cash/list')
}

export function cashOutConfigList() {
    return get('/cash/cashOutConfigList')
}

export function saveVersion(data) {
    return post('/version/save', data)
}

export function searchVersion(data) {
    return post('/version/search', data)
}

export function saveCopy(data) {
    return post('/version/saveCopy', data)
}

export function searchCopy(data) {
    return post('/version/searchCopy', data)
}

export function deleteCopy(data) {
    return post('/version/deleteCopy', data)
}

export function deleteVersion(id) {
    return get('/version/deleteVersion?id=' + id)
}

export function copyList() {
    return get('/version/copyList')
}

export function saveAdMaterial(data) {
    return post('/adMaterial/save', data)
}

export function searchAdMaterial(data) {
    return post('/adMaterial/search', data)
}

export function searchMaterialReport(data) {
    return post('/adMaterial/searchReport', data)
}

export function allPosition() {
    return get('/adMaterial/position')
}

export function allMaterialType() {
    return get('/adMaterial/materialType')
}

export function allDept() {
    return get('/game/dept')
}

export function allPlateName() {
    return get('/adMaterial/plateName')
}

//===================================================================================== 广告管理相关接口开始

// 获取顶部菜单栏的业务类型
export function allBusinessType() {
    return get('/ad/enum/position')
}

// 获取用户类型
export function allUserType() {
    return get('/ad/enum/user')
}

// 获取游戏内位置枚举
export function allInnerPositionType() {
    return get('/ad/enum/innerGame/position')
}

// 获取精选页位置枚举
export function allPartitionPositionType() {
    return get('/ad/enum/partition/position')
}

// 获取我的位置枚举
export function allMyPositionType() {
    return get('/ad/enum/my/position')
}

// 获取广告配置
export function listAdConfig(businessType) {
    return get('/ad/admin/list?businessType=' + businessType)
}

// 新增广告配置
export function addAdConfig(data) {
    return post('/ad/admin/add', data)
}

// 修改广告配置
export function editAdConfig(data) {
    return post('/ad/admin/update', data)
}

// 搜索广告管理
export function searchAdConfig(data) {
    return post('/ad/search', data)
}

// 修改广告配置开关
export function changeAdConfigState(id) {
    return get('/ad/changeState?id=' + id)
}

//===================================广告管理-游戏内矩阵业务类型下 部分接口 开始
// 获取指定广告管理已选游戏选品
export function searchAdConfigSelector(id) {
    return get('/ad/innerGame/searchSelected?id=' + id)
}

// 搜索已有游戏list
export function adSearchGameList(data) {
    return post('/ad/innerGame/searchGame', data)
}

// 批量新增已选游戏list
export function adSelectorBatchAdd(data) {
    return post('/ad/innerGame/batchAdd', data)
}

export function searchAdReport(data) {
    return post('/ad/searchAdReport', data)
}

//===================================广告管理-游戏内矩阵业务类型下 部分接口 结束

//========================================================================广告管理部分接口结束


//=================  模板配置相关接口开始

//获取全部简略模板配置信息  矩阵配置下拉框使用
export function allSimpleModelList() {
    return get('/model/allSimpleInfo')
}

// 搜索模板配置
export function searchModelConfig(data) {
    return post('/model/search', data)
}

// 新增模板配置
export function addModelConfig(data) {
    return post('/model/add', data)
}

// 修改广告配置
export function updateModelConfig(data) {
    return post('/model/update', data)
}

//删除模板配置
export function deleteModelConfig(id) {
    return get('/model/delete?id=' + id)
}

// 查询已选游戏选品
export function searchSelectedModelGames(id) {
    return get('/model/inner/selected?id=' + id)
}

// 搜索游戏信息
export function searchGames(data) {
    return post('/model/inner/searchGame', data)
}

//===============  模板配置部分接口结束

//商品兑换相关接口
export function goodsOriginTypes() {
    return get('/goods/type/origin')
}

export function goodsTypes() {
    return get('/goods/type/goodsType')
}

export function recordStateTypes() {
    return get('/goods/type/recordState')
}

export function listGoods() {
    return get('/goods/list')
}

export function saveGoods(data) {
    return post('/goods/save', data)
}

export function searchGoods(data) {
    return post('/goods/search', data)
}

export function uploadGoods(data) {
    return post('/goods/upload', data)
}

export function goodsExpand(data) {
    return post('/goods/sum', data)
}

export function saveExchangeRule(data) {
    return post('/exchange/save', data)
}

export function selectGoods(data) {
    return post('/exchange/select', data)
}

export function listExchangeRule() {
    return get('/exchange/list')
}

export function selectList(_id) {
    return post('/exchange/selectList/' + _id)
}

export function selectUpdate(data) {
    return post('/exchange/selectUpdate', data)
}

export function searchExchangeRecord(data) {
    return post('/goods/searchRecord', data)
}

export function updateExchangeRecordState(data) {
    return post('/goods/updateState', data)
}

// ===============贴子管理相关接口

// 搜索查询官方贴
export function searchOfficialPosts(data) {
    return post('/post/official/search', data)
}

// 新增官方贴
export function addOfficialPost(data) {
    return post('/post/add', data)
}

// 编辑官方贴
export function editOfficialPost(data) {
    return post('/post/edit', data)
}

//修改官方贴是否可见
export function changeOfficialDelete(did, id, state) {
    return get('/post/change/delete/' + did + '/' + id + '/' + state)
}

//修改官方贴是否置顶
export function changeOfficialTop(did, id, state) {
    return get('/post/change/top/' + did + '/' + id + '/' + state)
}

//查询一级评论
export function searchFirstPostComments(did, id, page, size) {
    return get('/post/search/comments/first/' + did + '/' + id + '/' + page + '/' + size)
}

//查询二级评论
export function searchSecondPostComments(did, id) {
    return get('/post/search/comments/second/' + did + '/' + id)
}

// 搜索查询普通贴
export function searchNormalPosts(data) {
    return post('/post/normal/search', data)
}

//禁言用户接口
export function bannedUser(did, type, time) {
    return get('/post/banned/' + did + '/' + type + '/' + time)
}

//查询用户禁言记录接口
export function bannedRecord(did) {
    return get('/post/banned/record/' + did)
}

//手动刷新mq
export function flushPostMQ(did, id) {
    return get('/post/flush/' + did + '/' + id)
}

// ===============官方贴结束

export function allOfficialUser() {
    return get('/post/allOfficialUser')
}

export function openOfficialUser() {
    return get('/post/openOfficialUser')
}

export function editOfficialUser(data) {
    return post('/post/editOfficialUser/', data)
}

export function deleteOfficialUser(data) {
    return post('/post/deleteOfficialUser', data)
}

export function editTopic(data) {
    return post('/post/editTopic', data)
}

export function searchTopic(data) {
    return post('/post/searchTopic', data)
}

//获取全部可用topic列表
export function openTopic() {
    return get('/post/openTopic')
}

export function searchPostReport(data) {
    return post('/post/searchPostReport', data)
}

export function adRuleList() {
    return get('/adRule/list')
}

export function deleteAdRule(adRuleId) {
    return get('/adRule/delete/' + adRuleId)
}

export function saveAdRule(data) {
    return post('/adRule/save', data)
}

export function updateAdRule(data) {
    return post('/adRule/update', data)
}

export function allScene() {
    return get('/adRule/allScene')
}

export function chatRoomTagList() {
    return get('/chat/listChatRoomTag')
}

export function chatRoomList() {
    return get('/chat/listChatRoom')
}

export function chatRooms() {
    return get('/chat/chatRooms')
}

export function searchCloseReport(data) {
    return post('/chat/searchCloseReport', data)
}

export function saveChatRoomTag(data) {
    return post('/chat/saveChatRoomTag', data)
}

export function shutUp(id, shutUp) {
    return get('/chat/changeShutUp/' + id + '/' + shutUp)
}

export function listChatRoomType() {
    return get('/chat/listChatRoomType')
}

export function saveChatRoom(data) {
    return post('/chat/saveChatRoom', data)
}

export function updateChatRoom(data) {
    return post('/chat/updateChatRoom', data)
}

export function batchUpdateChatRoomRanking(data) {
    return post('/chat/batchUpdateChatRoomRanking', data)
}

export function searchChatReport(data) {
    return post('/chat/searchChatRoomReport', data)
}

export function deleteChatRoomTag(id) {
    return get('/chat/delete/tag/' + id)
}


//================ 机器人相关接口
export function allRobotList() {
    return get('/admin/robot/all')
}

export function allEnableRobotList() {
    return get('/admin/robot/all/enable')
}

// 编辑机器人
export function editRobot(data) {
    return post('/admin/robot/edit', data)
}

// 新增机器人
export function addRobot(data) {
    return post('/admin/robot/add', data)
}

//机器人开关
export function changeRobotDelete(id, state) {
    return get('/admin/robot/change/' + id + '/' + state)
}

export function robotTypes() {
    return get('/admin/robot/types')
}

export function luckyConfigTypes() {
    return get('/admin/robot/types/lucky')
}

export function robotConfigList(id, roomType, configType) {
    return get('/admin/robot/config/list?id=' + id + '&roomType=' + roomType + '&configType=' + configType)
}

export function batchAddLuckyConfigs(data) {
    return post('/admin/robot/lucky/add', data)
}

export function batchAddNormalConfigs(data) {
    return post('/admin/robot/normal/add', data)
}

//红包币报表
export function searchCoinReport(data) {
    return post('/coin/report', data)
}

//分享报表
export function searchShareReport(data) {
    return post('/share/report', data)
}

//分类查询统计
export function searchClassifyRecord(data) {
    return post('/classify/search', data)
}

export function analysisClassifyRecordByDay(data) {
    return post('/classify/day', data)
}


export function feedStrategyList() {
    return get('/feed/feedStrategyList')
}

export function feedDelete(strategyId) {
    return get('/feed/delete?strategyId=' + strategyId)
}

export function feedSave(data) {
    return post('/feed/save', data)
}

export function feedUpdate(data) {
    return post('/feed/update', data)
}

export function feedbackSearch(data) {
    return post('/feedback/searchFeedback', data)
}

export function feedbackUpdate(id, state) {
    return get('/feedback/updateFeedback/' + id + '/' + state)
}

export function constantConfigList() {
    return get('/constantConfig/list')
}

export function searchConstantConfig(data) {
    return post('/constantConfig/search', data)
}

export function deleteConstantConfig(adRuleId) {
    return get('/constantConfig/delete/' + adRuleId)
}

export function saveConstantConfig(data) {
    return post('/constantConfig/save', data)
}

// 新游戏标签查询
export function allGameLabels() {
    return get('/game/label/all')
}

//新增、保存游戏标签
export function gameLabelSave(data) {
    return post('/game/label/save', data)
}

// 运营位相关
export function allOperationPosition() {
    return get('/operationPosition/list')
}

export function editOperationPosition(data) {
    return post('/operationPosition/saveAndUpdate', data)
}

export function allOperationPositionActivity(data) {
    return post('/operationPosition/activityList', data)
}

export function allSelect() {
    return get('/operationPosition/comboBoxList')
}

export function editOPActivity(data) {
    return post('/operationPosition/saveAndUpdateActivity', data)
}

export function deleteOPActivity(opaId) {
    return get('/operationPosition/deleteActivity/' + opaId)
}

// 角色管理
export function allRoles() {
    return get('/role/list/all')
}

export function saveRole(data) {
    return post('/role/save', data)
}

export function deleteRole(id) {
    return get('/role/delete?id=' + id)
}

//更新角色
export function roleUpdate(uid, roleId) {
    return get('/role/update?uid=' + uid + '&roleId=' + roleId)
}

// 资源管理
export function allPermissions() {
    return get('/permission/list/all')
}

export function savePermission(data) {
    return post('/permission/save', data)
}

export function deletePermission(id) {
    return get('/permission/delete?id=' + id)
}

// 获取用户权限信息树
export function userPermission(id) {
    return get('/permission/user?id=' + id)
}

//abTest
export function searchAbtestConfig(data) {
    return post('/abtest/search', data)
}

export function deleteAbTestConfig(adRuleId) {
    return get('/abtest/delete/' + adRuleId)
}

export function saveAbTestConfig(data) {
    return post('/abtest/save', data)
}

export function saveAdId(data) {
    return post('/ad/id/save', data)
}

export function searchAdId(data) {
    return post('/ad/id/search', data)
}

export function removeAdId(data) {
    return post('/ad/id/remove', data)
}

export function saveAdPopId(data) {
    return post('/ad/pop/save', data)
}

export function searchAPopId(data) {
    return post('/ad/pop/search', data)
}

export function removeAdPopId(data) {
    return post('/ad/pop/remove', data)
}

export function saveBlack(data) {
    return post('attribution/black/save', data)
}

export function queryBlack(data) {
    return post('attribution/black/query', data)
}

export function deleteBlack(data) {
    return post('attribution/black/delete', data)
}

export function savePackage(data) {
    return post('attribution/package/save', data)
}

export function queryPackage(data) {
    return post('attribution/package/query', data)
}

export function deletePackage(data) {
    return post('attribution/package/delete', data)
}

export function saveRule(data) {
    return post('attribution/rule/save', data)
}

export function queryRule(data) {
    return post('attribution/rule/query', data)
}

export function deleteRule(data) {
    return post('attribution/rule/delete', data)
}

export function enumBlack(data) {
    return get('attribution/black/enum', data)
}

export function orderSearch(data) {
    return post('/order/list', data)
}